import { render, staticRenderFns } from "./EditRepresentative.vue?vue&type=template&id=33c04a5f&"
import script from "./EditRepresentative.vue?vue&type=script&lang=js&"
export * from "./EditRepresentative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports